var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 0C52.8 0 0 52.8 0 118C0 183.2 52.8 236 118 236C183.2 236 236 183.2 236 118C236 52.8 183.2 0 118 0ZM128.8 181.6H107.3V159.5H128.8V181.6ZM126.3 147.8H109.1L106 54.4H130L126.3 147.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitNo);
export default __webpack_public_path__ + "static/media/visitNo.9951034ec4d6e3119a0927befd112d9f.svg";
export { ForwardRef as ReactComponent };